import {
  figureForChange,
  generatedChangeAuditProvenance,
} from '../../managers/document_redline_integration';
import {
  canInsertHere,
  plainTextForCopy,
  refusalFlash,
} from '../../managers/document_insert_here';

angular.module('LeasePilot').directive('comments', [
  '$rootScope',
  'ApiService',
  function($rootScope, ApiService) {
    var _pidMap = {};
    var _leaseEditorElement = null;
    var _addBtnElement = null;
    var _mutationObserverConfig = {
      characterData: true,
      subtree: true,
      childList: true,
      attributes: true,
    };
    var _observer = null;
    var $scope = null;

    var getElementAbsoluteOffset = el => {
      if (!el) {
        return 0;
      }

      var ret = el.offsetTop;
      while (el.offsetParent) {
        el = el.offsetParent;
        ret += el.offsetTop;
      }

      return ret;
    };

    var getElementOffset = el => {
      if (!el) {
        return 0;
      }

      var ret = el.offsetTop;
      if (el.offsetParent === _leaseEditorElement) return ret;
      else {
        while (el.offsetParent && el.offsetParent !== _leaseEditorElement) {
          el = el.offsetParent;
          ret += el.offsetTop;
        }
      }
      return ret;
    };

    var getMouseMoveTargetPid = evt => {
      var el = evt.srcElement;
      if (el) {
        while (el.parentElement && !el.getAttribute('pid')) {
          el = el.parentElement;
        }
        if (el.getAttribute('pid')) {
          return el;
        }
      }
      return null;
    };

    var updateExistingCommentsMarkersPosition = () => {
      var markers = document.querySelectorAll('.comments-marker');
      if (markers && markers.length > 0) {
        for (var i = 0; i < markers.length; i++) {
          var marker = markers[i];
          var pidel = _pidMap[marker.getAttribute('commentpid')];
          marker.style.top = `${getElementOffset(pidel) + 5}px`;
          marker.style.display = 'block';
        }
        updateCommentsDisplayAndEditorPosition();
      }
      updateAcceptRejectItemsPosition();
    };

    var updateCommentsDisplayAndEditorPosition = () => {
      if ($scope.currentCommentPid && _pidMap[$scope.currentCommentPid]) {
        var el = document.querySelector('#comments-display-warper');
        el.style.top = `${getElementOffset(
          _pidMap[$scope.currentCommentPid],
        )}px`;
      }
    };

    var updateAddCommentBtnPosition = evt => {
      if (_addBtnElement === null)
        _addBtnElement = document.querySelector('.addCommentBtn');
      if (_addBtnElement === null) return;
      var target = getMouseMoveTargetPid(evt);
      if (
        target &&
        $scope.comments &&
        !$scope.comments[target.getAttribute('pid')]
      ) {
        _addBtnElement.style.display = 'block';
        _addBtnElement.setAttribute('commentpid', target.getAttribute('pid'));
        _addBtnElement.style.top = `${getElementOffset(target) + 3}px`;
      } else if (target) {
        _addBtnElement.style.display = 'none';
      }
    };

    var updateAcceptRejectItemsPosition = () => {
      stopObserving();
      var elements = document.querySelectorAll('.annotation');
      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        element.classList.remove('annotation--add-space');
        var dataItem = $scope.annotations[elements[i].getAttribute('data-pid')];

        if (dataItem) {
          var anchorElementTop = getElementAbsoluteOffset(dataItem.container);
          if (anchorElementTop <= 0) {
            let container = document.querySelector(
              '[pid="' + dataItem.container.getAttribute('pid') + '"]',
            );
            anchorElementTop = getElementAbsoluteOffset(container);
          }
          var currentTop = getElementAbsoluteOffset(element);
          if (currentTop !== anchorElementTop) {
            var containerTop = getElementAbsoluteOffset(element.parentElement);
            element.style.top = `${anchorElementTop - containerTop}px`;
            currentTop = getElementAbsoluteOffset(element);
          }
          if (currentTop < 150) {
            element.classList.add('annotation--add-space');
          }
        }
      }
      startObserving();
    };

    var startObserving = () => {
      _observer.observe(document.body, _mutationObserverConfig);
    };

    var stopObserving = () => {
      _observer.disconnect();
    };

    function getDiffItem(index) {
      return document.querySelector(`.diff-item[diff-index="${index}"]`);
    }

    function findLeaseVar(diffItemNodes) {
      let leaseVarNode;

      for (let node of diffItemNodes) {
        const parent = node.closest(
          '.transformed--lease-var:not([non-click="true"])',
        );

        if (parent) {
          leaseVarNode = parent;
          break;
        }
      }

      return leaseVarNode;
    }

    function textFromHtml(html, selector) {
      if (!html) return null;

      const host = document.createElement('div');
      host.innerHTML = String(html);
      const nodes = selector
        ? Array.from(host.querySelectorAll(selector))
        : [host];
      const text = nodes
        .map(node => node.textContent)
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim();

      return text || null;
    }

    function renderedChangeText(request) {
      if (!request) return null;

      const marker =
        request._annotationNode ||
        document.querySelector(
          `.lease.lease--modified .diff-item[diff-index="${request._index}"]`,
        );
      if (!marker) return null;

      const text = marker.textContent.replace(/\s+/g, ' ').trim();
      return text || null;
    }

    const rejectionReasons = [
      {
        code: 'outside_approved_position',
        label: 'Outside our approved position',
      },
      {
        code: 'legal_or_compliance_risk',
        label: 'Legal or compliance risk',
      },
      {
        code: 'economics_not_acceptable',
        label: 'Economics are not acceptable',
      },
      {
        code: 'drafting_or_scope_problem',
        label: 'Drafting or scope problem',
      },
      { code: 'already_addressed', label: 'Already addressed elsewhere' },
      { code: 'deal_specific_reason', label: 'Deal-specific reason' },
      { code: 'other', label: 'Other — explain below' },
    ];

    function changeAuditData(request, decision, decisionReason, figure) {
      const html = request && request.Html;
      const hasMarkedChanges =
        html && /<(?:ins|del)(?:\s|>)/i.test(String(html));
      let beforeText = null;
      let afterText = null;

      if (hasMarkedChanges) {
        beforeText = textFromHtml(html, 'del');
        afterText = textFromHtml(html, 'ins');
      } else if (request && request.Type === 'del') {
        beforeText = textFromHtml(html) || renderedChangeText(request);
      } else {
        afterText =
          textFromHtml(html) ||
          renderedChangeText(request) ||
          (request && request.proposal
            ? textFromHtml(request.proposal.content)
            : null);
      }

      return {
        ...(figure || {}),
        diffIndex: request._index,
        beforeText,
        afterText,
        decision,
        decisionReason,
      };
    }

    function auditableRequests(annotation, request) {
      if (request) return [request];
      if (!annotation || !Array.isArray(annotation.items)) return [];

      return annotation.items.filter(item => item._showAcceptReject);
    }

    function requestAuditData(annotation, request, decision, decisionReason) {
      const data = { context: $rootScope.getContext() };
      const provenance = generatedChangeAuditProvenance(annotation, request);
      const changes = auditableRequests(annotation, request).map(item =>
        changeAuditData(
          item,
          decision,
          decisionReason,
          figureForChange(annotation, item),
        ),
      );

      if (changes.length === 1) {
        Object.assign(data, changes[0]);
      } else {
        data.changes = changes;
      }

      if (provenance) {
        data.documentChangeProvenance = provenance;
      }

      return data;
    }

    // The change text belongs in the ledger row, not in the analytics event.
    // `window.track` persists its payload to the events table and forwards a
    // channelled event to Tinybird, so anything put here is a second copy of
    // counterparty lease prose living outside the company-scoped ledger P0-02
    // built to hold it. Indexes and a count say what the event needs to say
    // about the decision without carrying the document (design §16).
    function trackingAuditData(auditData) {
      const changes = auditData.changes || [auditData];
      const tracking = { context: auditData.context };

      if (auditData.documentChangeProvenance) {
        tracking.documentChangeProvenance = auditData.documentChangeProvenance;
      }

      tracking.decision = changes.length ? changes[0].decision : null;
      tracking.diffIndexes = changes.map(change => change.diffIndex);
      tracking.changeCount = changes.length;

      return tracking;
    }

    // An observation of a decision the drafter has already made and saved. A
    // failed write must not take the decision down with it: awaiting this
    // would skip `status = 'resolved'` and the tracking event on any 500 or
    // dropped connection, leaving an applied change on an unresolved card.
    // Same shape as `trackImportOutcome` in deal_terms_import_service.
    function decisionPayloads(auditData) {
      const changes = auditData.changes || [auditData];
      const documentId = $rootScope.getLeaseId();

      return changes.map(change => ({
        documentId: documentId,
        context: auditData.context,
        diffIndex: change.diffIndex,
        beforeText: change.beforeText,
        afterText: change.afterText,
        decision: change.decision,
        decisionReason: change.decisionReason,
        // lp-018 Phase 1. Null on every change but the one its card spoke for,
        // and null entirely where the concept carries no ladder — which is
        // about half of them.
        requestedValue: change.requestedValue ?? null,
        valueMetric: change.valueMetric ?? null,
      }));
    }

    // Not awaiting the write is right; staying silent about a failed one was a
    // separate decision that had not been taken. The drafter types a rejection
    // reason precisely so the reason is on the record, watches the card resolve,
    // and — before this — had no way to learn the row was never written. A lost
    // record is the one failure this product cannot let look like success.
    //
    // The payload is kept rather than the error so a retry replays exactly what
    // was lost. It holds change text, so it lives on the annotation and is never
    // logged or sent to tracking.
    function markLedgerFailure(annotation, payload) {
      if (!annotation) return;

      annotation._ledgerFailedWrites = annotation._ledgerFailedWrites || [];
      annotation._ledgerFailedWrites.push(payload);
      annotation._ledgerRetrying = false;
      // The .catch runs outside the digest that applied the decision.
      $scope.$applyAsync();
    }

    function sendDecisionPayload(annotation, payload) {
      return ApiService.recordCounterpartyDecision(payload).catch(function(
        error,
      ) {
        if (window.isDebug) {
          console.warn('[counterpartyLedger] decision write failed', error);
        }
        markLedgerFailure(annotation, payload);
      });
    }

    function recordCounterpartyDecision(annotation, auditData) {
      if (
        !ApiService ||
        typeof ApiService.recordCounterpartyDecision !== 'function'
      ) {
        return;
      }

      decisionPayloads(auditData).forEach(payload => {
        sendDecisionPayload(annotation, payload);
      });
    }

    var retryLedgerWrites = annotation => {
      if (
        !annotation ||
        !annotation._ledgerFailedWrites ||
        !annotation._ledgerFailedWrites.length
      ) {
        return;
      }

      // Drained before the replay so a second failure re-queues cleanly rather
      // than doubling the backlog.
      const pending = annotation._ledgerFailedWrites;
      annotation._ledgerFailedWrites = [];
      annotation._ledgerRetrying = true;

      Promise.all(
        pending.map(payload => sendDecisionPayload(annotation, payload)),
      ).then(function() {
        annotation._ledgerRetrying = false;
        $scope.$applyAsync();
      });
    };

    var hasLedgerFailure = annotation =>
      Boolean(
        annotation &&
          annotation._ledgerFailedWrites &&
          annotation._ledgerFailedWrites.length,
      );

    var acceptAll = async annotation => {
      const appScope = $rootScope.findAppScope();
      const auditData = requestAuditData(annotation, null, 'accept');
      await appScope.annotationsHelper.actions.acceptAndSave(annotation);
      recordCounterpartyDecision(annotation, auditData);
      annotation.accepted = true;
      annotation.rejected = false;
      annotation.status = 'resolved';

      window.track.event(
        new AcceptAllTenantRequestsEvent(trackingAuditData(auditData)),
      );
    };

    var acceptRequest = async (annotation, request) => {
      const appScope = $rootScope.findAppScope();
      const diffItem = getDiffItem(request._index);
      const auditData = requestAuditData(annotation, request, 'accept');

      const requestIndex = annotation.items.indexOf(request);
      if (requestIndex !== annotation.items.length - 1) {
        appScope.annotationsHelper.jumpToRequest(
          annotation.items[requestIndex + 1]._index,
        );
      }

      await appScope.annotationsHelper.actions.acceptAndSave(diffItem);
      recordCounterpartyDecision(annotation, auditData);

      const resolvedItems = annotation.items.filter(
        item => item._status !== 'unresolved',
      );
      if (resolvedItems.length === annotation.items.length) {
        const accepted = resolvedItems.filter(
          item => item._status === 'accepted',
        );
        const rejected = resolvedItems.filter(
          item => item._status === 'rejected',
        );

        if (accepted.length === annotation.items.length) {
          annotation.accepted = true;
        } else if (rejected.length === annotation.items.length) {
          annotation.rejected = true;
        } else {
          annotation.manual = true;
        }

        annotation.status = 'resolved';

        window.track.event(
          new AcceptIndividualTenantRequestEvent(trackingAuditData(auditData)),
        );
      }
    };

    // INSERT — place this suggestion where the caret is instead of where we
    // guessed. The sequence is rebuild → accept → delete, owned by the app
    // scope because it needs the list-item builder and the accept path; this
    // directive only routes the click and reports a refusal.
    var insertHere = async (annotation, request) => {
      const appScope = $rootScope.findAppScope();
      const target = request || annotation.items[0];

      const result = await appScope.insertGeneratedRequestAtCaret(target);
      if (result && !result.ok) {
        // Two kinds of refusal. A misplaced caret is one click from working, so
        // say where to click. A structural refusal — inside a table, or a form
        // with no paragraph style — can never work, so hand over the text
        // rather than telling the drafter their goal is unreachable when only
        // our route to it is.
        if (result.remedy === 'copy') {
          const copied = await copySuggestionText(target);
          appScope.$emit('flash:error', refusalFlash(result, copied));
          return;
        }

        appScope.$emit('flash:error', result.message);
        return;
      }

      annotation.accepted = true;
      annotation.status = 'resolved';
    };

    // Plain prose only: the text is already plain, but this is the value that
    // leaves the application and the neighbouring source of "the suggestion's
    // text" is the card html, which carries review markers.
    var copySuggestionText = async item => {
      const text = plainTextForCopy(item);
      if (!text) return false;

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
          return true;
        }
      } catch (error) {
        // Clipboard permission can be refused, and a denied copy is not a
        // reason to lose the refusal message the drafter still needs.
        console.warn('[insertHere] clipboard write refused', error);
      }

      return false;
    };

    // "Revise this change" used to end in a string the drafter had to select out
    // of a 12px box and retype. Every other proposal in this system lives as a
    // redline in the lease; this one lived in the panel. Placing it is the whole
    // point of making the recommendation.
    //
    // Placing our language in answer to their edit IS the revise decision, so it
    // is one act and one ledger row: their change is rejected, ours stands in
    // its place, and the row records `revise` rather than a reject that loses
    // the fact that we answered it. `revise` carries no rejection reason — the
    // replacement language is the reason.
    var insertRevisedText = async (annotation, entry) => {
      const card = entry && entry.card;
      const revised = card && String(card.revisedText || '').trim();
      if (!revised || !entry.request) return;

      const appScope = $rootScope.findAppScope();
      // Structure is borrowed from the change it answers so the insertion lands
      // in the part of the document the drafter is reading; only the content is
      // the model's.
      const synthetic = {
        ...entry.request,
        proposal: {
          ...(entry.request.proposal || {}),
          content: revised,
        },
      };

      const result = await appScope.insertGeneratedRequestAtCaret(synthetic);
      if (result && !result.ok) {
        if (result.remedy === 'copy') {
          const copied = await copySuggestionText(synthetic);
          appScope.$emit('flash:error', refusalFlash(result, copied));
          return;
        }

        appScope.$emit('flash:error', result.message);
        return;
      }

      const auditData = requestAuditData(annotation, entry.request, 'revise');
      const diffItem = getDiffItem(entry.request._index);
      await appScope.annotationsHelper.actions.rejectAndSave(diffItem);
      recordCounterpartyDecision(annotation, auditData);

      const resolvedItems = annotation.items.filter(
        item => item._status !== 'unresolved',
      );
      if (resolvedItems.length === annotation.items.length) {
        // Mixed by construction: their change is rejected and ours was placed,
        // which is neither a clean accept nor a clean reject of the annotation.
        annotation.manual = true;
        annotation.status = 'resolved';
      }
    };

    var canInsert = annotation => {
      if (!annotation || !Array.isArray(annotation.items)) return false;
      // One card, one suggestion for generated changes; a multi-request card is
      // a tenant import, where placement was never ours to choose.
      return (
        annotation.items.length === 1 && canInsertHere(annotation.items[0])
      );
    };

    var rejectAll = async (annotation, decisionReason) => {
      const appScope = $rootScope.findAppScope();
      const auditData = requestAuditData(
        annotation,
        null,
        'reject',
        decisionReason,
      );
      await appScope.annotationsHelper.actions.rejectAndSave(annotation);
      recordCounterpartyDecision(annotation, auditData);

      annotation.rejected = true;
      annotation.accepted = false;
      annotation.status = 'resolved';

      window.track.event(
        new RejectAllTenantRequestsEvent(trackingAuditData(auditData)),
      );
    };

    var rejectRequest = async (annotation, request, decisionReason) => {
      const appScope = $rootScope.findAppScope();
      const diffItem = getDiffItem(request._index);
      const auditData = requestAuditData(
        annotation,
        request,
        'reject',
        decisionReason,
      );

      const requestIndex = annotation.items.indexOf(request);
      if (requestIndex !== annotation.items.length - 1) {
        appScope.annotationsHelper.jumpToRequest(
          annotation.items[requestIndex + 1]._index,
        );
      }

      await appScope.annotationsHelper.actions.rejectAndSave(diffItem);
      recordCounterpartyDecision(annotation, auditData);

      const resolvedItems = annotation.items.filter(
        item => item._status !== 'unresolved',
      );
      if (resolvedItems.length === annotation.items.length) {
        const accepted = resolvedItems.filter(
          item => item._status === 'accepted',
        );
        const rejected = resolvedItems.filter(
          item => item._status === 'rejected',
        );

        if (accepted.length === annotation.items.length) {
          annotation.accepted = true;
        } else if (rejected.length === annotation.items.length) {
          annotation.rejected = true;
        } else {
          annotation.manual = true;
        }

        annotation.status = 'resolved';

        window.track.event(
          new RejectIndividualTenantRequestEvent(trackingAuditData(auditData)),
        );
      }
    };

    var beginRejection = (annotation, request) => {
      $scope.rejectionDraft = {
        annotation: annotation,
        request: request || null,
        code: '',
        detail: '',
        submitting: false,
      };
    };

    var isRejecting = (annotation, request) => {
      const draft = $scope.rejectionDraft;
      return (
        !!draft &&
        draft.annotation === annotation &&
        draft.request === (request || null)
      );
    };

    var rejectionReasonIsValid = () => {
      const draft = $scope.rejectionDraft;
      if (!draft || !draft.code) return false;
      return draft.code !== 'other' || !!draft.detail.trim();
    };

    var cancelRejection = () => {
      $scope.rejectionDraft = null;
    };

    var confirmRejection = async () => {
      const draft = $scope.rejectionDraft;
      if (!rejectionReasonIsValid() || draft.submitting) return;

      draft.submitting = true;
      const decisionReason = {
        code: draft.code,
        detail: draft.detail.trim() || null,
      };

      try {
        if (draft.request) {
          await rejectRequest(draft.annotation, draft.request, decisionReason);
        } else {
          await rejectAll(draft.annotation, decisionReason);
        }
        cancelRejection();
      } catch (error) {
        // Previously this threw past the `finally` and left the panel open with
        // the reason still typed in it and nothing said. An open form that has
        // stopped saying "Rejecting…" is indistinguishable from one that was
        // never submitted, so the drafter's next move is to press the button
        // again — against a change that may already have been rejected.
        if (window.isDebug) {
          console.warn('[counterpartyLedger] reject failed', error);
        }
        draft.error =
          'This change could not be rejected. Your reason is still here — try again.';
      } finally {
        if ($scope.rejectionDraft === draft) draft.submitting = false;
        // `rejectAndSave` awaits a `$q` deferred, so this continuation runs as
        // a microtask after that digest has already drained. The neighbouring
        // `annotation.rejected = true` gets away with it because it only
        // repaints a card that is about to be redrawn anyway; this panel is
        // the whole feedback for the action and must not sit open waiting for
        // an unrelated digest to clear it.
        $scope.$applyAsync();
      }
    };

    var adjustManually = annotation => {
      const appScope = $rootScope.findAppScope();
      const diffItemNodes = document.querySelectorAll(
        `.lease.lease--modified .annotation[data-pid="${annotation.pid}"] .diff-item`,
      );
      const element = findLeaseVar(diffItemNodes);

      appScope.leftPane = 'deal-terms';
      appScope.safeApply();

      setTimeout(() => {
        leftSideEditorSearch.searchByLeaseVarElement(element);
      });
    };

    var adjustRequestManually = (annotation, request) => {
      const appScope = $rootScope.findAppScope();
      const diffItemNodes = document.querySelectorAll(
        `.lease.lease--modified .diff-item[diff-index="${request._index}"]`,
      );
      const element = findLeaseVar(diffItemNodes);

      appScope.leftPane = 'deal-terms';
      appScope.safeApply();

      setTimeout(() => {
        leftSideEditorSearch.searchByLeaseVarElement(element);
      });
    };

    var markAsResolved = annotation => {
      const appScope = $rootScope.findAppScope();

      let currentRequest;
      let currentAnnotationItem;
      for (let i = 0; i < annotation.items.length; i++) {
        currentRequest = annotation.items[i];
        currentAnnotationItem = getDiffItem(currentRequest._index);
        appScope.annotationsHelper.resolveAnnotation(
          currentAnnotationItem,
          'manual',
        );
      }

      annotation.manual = true;
      annotation.status = 'resolved';

      window.track.event(
        new MarkAllTenantRequestsAsResolvedEvent({
          context: $rootScope.getContext(),
        }),
      );
    };

    var markRequestAsResolved = (annotation, request) => {
      const appScope = $rootScope.findAppScope();
      const currentAnnotationItem = getDiffItem(request._index);

      const requestIndex = annotation.items.indexOf(request);
      if (requestIndex !== annotation.items.length - 1) {
        appScope.annotationsHelper.jumpToRequest(
          annotation.items[requestIndex + 1]._index,
        );
      }

      appScope.annotationsHelper.resolveAnnotation(
        currentAnnotationItem,
        'manual',
      );

      const resolvedItems = annotation.items.filter(
        item => item._status !== 'unresolved',
      );
      if (resolvedItems.length === annotation.items.length) {
        const accepted = resolvedItems.filter(
          item => item._status === 'accepted',
        );
        const rejected = resolvedItems.filter(
          item => item._status === 'rejected',
        );

        if (accepted.length === annotation.items.length) {
          annotation.accepted = true;
        } else if (rejected.length === annotation.items.length) {
          annotation.rejected = true;
        } else {
          annotation.manual = true;
        }

        annotation.status = 'resolved';

        window.track.event(
          new MarkIndividualTenantRequestAsResolvedEvent({
            context: $rootScope.getContext(),
          }),
        );
      }
    };

    var preview = () => {
      const appScope = $rootScope.findAppScope();
      appScope.annotationsHelper.preview();

      window.track.event(
        new PreviewTenantRequestsEvent({
          context: $rootScope.getContext(),
        }),
      );
    };

    function comments(scope, element, attr) {
      $scope = scope;
      $scope.getElementAbsoluteOffset = getElementAbsoluteOffset;
      $scope.acceptAll = acceptAll;
      $scope.acceptRequest = acceptRequest;
      $scope.insertHere = insertHere;
      $scope.canInsert = canInsert;
      $scope.rejectionReasons = rejectionReasons;
      $scope.beginRejection = beginRejection;
      $scope.isRejecting = isRejecting;
      $scope.rejectionReasonIsValid = rejectionReasonIsValid;
      $scope.cancelRejection = cancelRejection;
      $scope.confirmRejection = confirmRejection;
      $scope.adjustManually = adjustManually;
      $scope.adjustRequestManually = adjustRequestManually;
      $scope.markAsResolved = markAsResolved;
      $scope.markRequestAsResolved = markRequestAsResolved;
      $scope.preview = preview;
      $scope.hasLedgerFailure = hasLedgerFailure;
      $scope.retryLedgerWrites = retryLedgerWrites;
      $scope.insertRevisedText = insertRevisedText;

      let _leaseEditorElement = document.querySelector(
        '.lease.lease--modified',
      );

      _observer = new MutationObserver(
        _.throttle(updateExistingCommentsMarkersPosition, 250, {
          leading: false,
          trailing: true,
        }),
      );

      startObserving();

      window.addEventListener(
        'resize',
        _.throttle(updateExistingCommentsMarkersPosition, 250, {
          leading: false,
          trailing: true,
        }),
      );

      _leaseEditorElement.addEventListener(
        'mouseover',
        _.throttle(updateAddCommentBtnPosition, 250, {
          leading: false,
          trailing: true,
        }),
      );
    }

    return {
      link: comments,
      restrict: 'E',
      templateUrl: 'comments.html',
    };
  },
]);
